<template>
    <div>
        <div class="item-view" :class="[{isbgc: (i%2) == 1}]" v-for="(item,i) in projectData" :key="i">
            <div :class="['inner' , {isrow : (i%2) == 1}]">
                <div class="img-box" @click="gotoUrl(item.url)">
                    <img :src="item.img" alt="">
                </div>

                <div class="cont-box">
                    <p class="title">{{item.title}}</p>

                    <p v-if="item.p1">
                        {{item.p1[0]}}
                        <span class="colorBold" v-if="item.p1[1]">{{item.p1[1]}}</span>
                        <span v-if="item.p1[2]"></span> {{item.p1[2]}}
                    </p>

                    <p v-if="item.p2 && item.p2.length !== 0">
                        {{item.p2[0]}}
                        <span class="colorBold" v-if="item.p2[1]">{{item.p2[1]}}</span>
                        <span v-if="item.p2[2]"></span> {{item.p2[2]}}
                    </p>

                    <el-button 
                    v-if="item.url"
                    type="primary" 
                    @click="gotoUrl(item.url)"
                    >
                        了解更多
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        projectData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        gotoUrl(url) {
            if (url) window.open(url);
        },
    },
};
</script>

<style lang="scss" scoped>
//双数样式
.isbgc {
    background-color: #f8fcfe;
}
.isrow {
    display: flex;
    flex-direction: row-reverse !important;
}

.item-view {
    .inner {
        padding: 54px 0;
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .img-box {
            width: 530px;
            height: 304px;
            cursor: pointer;
            // overflow: hidden;
            img {
                width: 530px;
                height: 304px;
                transition: all 0.3s;
                &:hover {
                    transform: scale(1.08);
                }
            }
        }

        .cont-box {
            width: 560px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            p {
                margin-bottom: 40px;
                line-height: 26px;
            }

            .title {
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 35px;
            }

            .el-button {
                width: 100px;
                height: 34px;
                line-height: 9px;
            }
            .colorBold {
                font-weight: bold;
                color: #8a1f94;
            }
        }
    }
}
</style>
